module.exports = __webpack_public_path__ + "static/media/Adrift-Hotel.33ffc519.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/screenshots/Adrift-Hotel.png
// module id = 95
// module chunks = 0